import MODULE_ID from './moduleId';
import routeHandler from './routes';

const module = {
  moduleType: 'Messaging', // Used in module configurations
  moduleId: MODULE_ID, // Used as identifier for vuex module
  api: 'messaging', // path of ui
  routeHandler,

  /**
   * Lifecycle method called after the user has been authenticated.
   * It is called in lifecyclePhases#initializeSocketIo for every configured module that implements
   * this function.
   * Socket rooms should be subscribed here in case the app needs to receive
   * socket.io events even if the module is not displayed.
   * @param {*} rootState vuex root state
   * @param {*} commit vuex commit object
   * @param {*} socket socket instance (namespaced, but does not matter)
   */
  initModuleSockets: ({ rootState, commit, dispatch, socket }) => {
    let { userId, tenant } = rootState.configs.user;
    const userRoom = `${tenant}/${userId}`;
    console.debug('initModuleSockets callback - messaging not used currently', userRoom);
  },
};

export default module;
